module.exports = __webpack_public_path__ + "img/logo.2b68e5d8.png";